import { Fragment } from "react";

import { Box, Typography } from "@mui/material";

import { HierarchyModelBase } from "#/features/Hierarchy/types";
// eslint-disable-next-line deprecate/import
import { localDayJs } from "@/common/packages/dayjs";

export const HierarchyItem = ({
  selected,
  prefix,
  item,
  edit,
  postfix,
  onClick,
}: {
  selected?: boolean;
  prefix?: JSX.Element;
  item: HierarchyModelBase;
  edit?: JSX.Element;
  postfix?: JSX.Element;
  onClick?: () => void;
}) => {
  return (
    <Fragment key={item.id}>
      <Box
        className={`ContainerItem ${selected ? "selected" : ""} ${item.archivedAt ? "archived" : ""}`}
        onClick={() => onClick?.()}
      >
        {prefix}

        <Box className={"name"}>
          <Typography>{item.name}</Typography>
          {edit}
        </Box>

        {postfix}
      </Box>
      {item.archivedAt && (
        <Box className={`ContainerItem archived-info`}>
          <Typography variant={"subtitle2"}>
            Archived on {localDayJs(item.archivedAt).format("MM-DD-YYYY")}.
          </Typography>
        </Box>
      )}
    </Fragment>
  );
};
